import { render, staticRenderFns } from "./researchEducation.vue?vue&type=template&id=6ed00240&scoped=true"
import script from "./researchEducation.vue?vue&type=script&lang=js"
export * from "./researchEducation.vue?vue&type=script&lang=js"
import style0 from "./researchEducation.vue?vue&type=style&index=0&id=6ed00240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed00240",
  null
  
)

export default component.exports